import React from 'react';
import { Route } from 'react-router-dom';

const AppRoute = ({path, component, layout: Layout, isAuthProtected, children}: any) => (
  <Layout>
    <Route path={path} component={component} exact/>
    {
      children.length > 0 &&
      children.map((route, idx) => (
        <Route
          key={idx}
          path={route.path}
          component={route.component}
          exact
        />
      ))
    }
  </Layout>
);

export default AppRoute;
